/**
 * Utility functions for handling money and currency values in the WebApp.
 * Mirrored from Shared/common logic.
 */

/**
 * Formats a number as a German price string (e.g. 1234.56 -> "1.234,56 €").
 */
export function formatPrice(
    amount: number | null | undefined,
    options: {
        currency?: boolean; // default: true
        currencySymbol?: string; // default: '€'
    } = {}
): string {
    if (amount === null || amount === undefined || isNaN(amount as number)) return 'n.a.';

    const isInteger = amount % 1 === 0;
    const formatter = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: isInteger ? 0 : 2,
        maximumFractionDigits: 2,
    });

    const formattedNumber = formatter.format(amount);

    if (options.currency === false) {
        return formattedNumber;
    }

    const symbol = options.currencySymbol || '€';
    return `${formattedNumber} ${symbol}`;
}
